import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "../../../shared/i18n";
import cloneDeep from "lodash/cloneDeep";
import helperService from "@/core/services/helper.service";

export default class PremiumsFormData extends BaseModel {
  minimum_premium = null;
  premiums = [];

  constructor(data = {}, tax_rate = null) {
    super();
    data = helperService.reverseCalculateTiers(data, tax_rate)
    Object.assign(this, {...data});
  }

  getData() {
    return {
      minimum_premium: this.minimum_premium,
      premiums: this.premiums
    }
  }

  rules = {
    minimum_premium: 'required',
  };

  attributeLabels = {
    minimum_premium: i18n.t('Minimum Premium'),
    premiums: i18n.t('Premiums')
  }

  toJSON() {
    let data = cloneDeep(super.toJSON());
    data = helperService.calculateTiers(data)
    return data
  }
}